import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [authState, setAuthState] = useState({
		isAuthenticated: false,
		isLoading: true,
	});
	const [userSession, setUserSession] = useState(null);

	// Fetch and validate user session and subscription status
	const validateUser = async () => {
		try {
			const response = await fetch(
				'https://www.mylandscapedesign.com/_functions/auth/getUserSession',
				{
					method: 'GET',
					credentials: 'include',
				}
			);

			if (!response.ok) {
				throw new Error('Failed to fetch user session');
			}

			const data = await response.json();
			console.log('getUserSession data', JSON.stringify(data));
			if (data.hasActiveSubscription) {
				setAuthState({ isAuthenticated: true, isLoading: false });
				setUserSession(data); // Store user session
			} else {
				// Redirect to plans and pricing page of main site if no active subscription
				console.error('User has no active subscription:', data);
				// window.location.href = 'https://www.mylandscapedesign.com/plans-pricing';
			}
		} catch (error) {
			console.error('Authentication error:', error);
			// Redirect on failure
			console.error('Redirecting to main site...');
			// window.location.href = 'https://www.mylandscapedesign.com';
		}
	};

	useEffect(() => {
		validateUser();
	}, []);

	return (
		<AuthContext.Provider value={{ authState, userSession }}>
			{!authState.isLoading ? children : <div>Loading...</div>}
		</AuthContext.Provider>
	);
};

// Custom hook to use authentication context
export const useAuth = () => useContext(AuthContext);
